import { apiClient } from '@shared/utils/api-client';
import { compressImageFiles } from '@shared/utils/compress-image';
import type {
  SellerSupportMessage,
  SellerSupportMessagesResponse,
} from '../types';

export const SELLER_SUPPORT_CHAT_MAX_IMAGES = 5;

export const sellerSupportChatApi = {
  getUnreadCount: () => apiClient.get<{ count: number }>('/seller-support-chat/me/unread-count'),

  getMessages: (params?: { limit?: number; beforeId?: number }) => {
    const search = new URLSearchParams();
    if (params?.limit != null) search.set('limit', String(params.limit));
    if (params?.beforeId != null) search.set('beforeId', String(params.beforeId));
    const q = search.toString();
    return apiClient.get<SellerSupportMessagesResponse>(
      `/seller-support-chat/me/messages${q ? `?${q}` : ''}`,
    );
  },

  sendMessage: async (body: string, images?: File[]) => {
    const formData = new FormData();
    const trimmed = body.trim();
    if (trimmed) formData.append('body', trimmed);
    if (images && images.length > 0) {
      const compressed = await compressImageFiles(images);
      compressed.forEach((file) => formData.append('images', file));
    }
    return apiClient.post<SellerSupportMessage>('/seller-support-chat/me/messages', formData);
  },

  markRead: () => apiClient.patch<{ ok: boolean; marked: number }>('/seller-support-chat/me/read', {}),
};
